import * as React from "react";

function IconLOUnlimited(props) {
  return (
    <svg width={48} height={48} viewBox="0 0 72 72" fill="none" {...props}>
      <circle cx={35.625} cy={36.375} r={34.875} fill="#79B9FC" />
      <circle
        cx={35.625}
        cy={36.375}
        r={34.375}
        stroke="#000"
        strokeOpacity={0.08}
      />
      <g fill="#fff">
        {/* Outer circle */}
        <path d="M35.625 18.375c-9.94 0-18 8.06-18 18s8.06 18 18 18 18-8.06 18-18-8.06-18-18-18zm0 33.5c-8.56 0-15.5-6.94-15.5-15.5s6.94-15.5 15.5-15.5 15.5 6.94 15.5 15.5-6.94 15.5-15.5 15.5z" />
        {/* Vertical meridian (ellipse) */}
        <path d="M35.625 20.875c-3.59 0-6.5 6.94-6.5 15.5s2.91 15.5 6.5 15.5 6.5-6.94 6.5-15.5-2.91-15.5-6.5-15.5zm0 28.5c-1.68 0-4-5.56-4-13s2.32-13 4-13 4 5.56 4 13-2.32 13-4 13z" />
        {/* Horizontal line (equator) */}
        <rect x={19.125} y={35.125} width={33} height={2.5} rx={1.25} />
        {/* Latitude line top */}
        <rect x={23.125} y={28.125} width={25} height={2} rx={1} />
        {/* Latitude line bottom */}
        <rect x={23.125} y={42.625} width={25} height={2} rx={1} />
      </g>
    </svg>
  );
}

const MemoIconLOUnlimited = React.memo(IconLOUnlimited);
export default MemoIconLOUnlimited;
